import type { FunctionComponent } from 'react';
import { useMemo } from 'react';

import {
    Screens,
    updateTemporaryMessagesCache,
    useTemporaryMessages,
} from '@shared/temporary-messages';
import type { PublicTemporaryMessage } from '@api-client/temporary-messages';

import { DevToolsToggle } from '../DevToolsToggle';

const SIMULATED_TEMPORARY_MESSAGE: PublicTemporaryMessage = {
    id: 'SIMULATED_TEMPORARY_MESSAGE_ID',
    screens: Object.values(Screens),
    localizedText: {
        title: 'Temporary message - SCREEN and its url mapping need to be defined for every page',
        preview:
            'When you set vertical position of elements(top) please double-check if layout of page is not broken when temporary message preview is displayed. To make it work with temporary messages use sass <b>tmpMessageMixin.with-temporary-message</b>.',
        body: 'When you set vertical position of elements(top) please double-check if layout of page is not broken when temporary message preview is displayed. To make it work with temporary messages use sass <b>tmpMessageMixin.with-temporary-message</b>. Do not forget about the tmp messages collapsed state and different screen sizes.',
    },
    closeable: false,
    severity: 'INFO',
};

export const SimulateTemporaryMessageToggle: FunctionComponent = () => {
    const { data: temporaryMessages } = useTemporaryMessages();
    const isSimulatedTemporaryMessageActive = useMemo(
        () =>
            !!temporaryMessages?.some(
                (temporaryMessage) => temporaryMessage.id === SIMULATED_TEMPORARY_MESSAGE.id,
            ),
        [temporaryMessages],
    );

    const onSimulatedTemporaryMessageToggle = (active: boolean) => {
        const data = active ? [SIMULATED_TEMPORARY_MESSAGE] : [];
        updateTemporaryMessagesCache({ data });
    };

    return (
        <DevToolsToggle
            active={isSimulatedTemporaryMessageActive}
            label="Simulate temporary message"
            onToggle={onSimulatedTemporaryMessageToggle}
        />
    );
};
